<template>
  <div class="main-container">
    <div class="recommend" v-if="recommend.first.id">
      <router-link :to="{ name: 'NewsShow', params: { id: recommend.first.id } }">
        <div
          class="recommend-left f-left"
          :style="{ backgroundImage: 'url(' + recommend.first.thumb_img + ')' }"
        >
          <div class="recommend-title" :title="recommend.first.title">
            {{ recommend.first.title }}
          </div>
        </div>
      </router-link>
      <div class="recommend-right f-right">
        <router-link
          :to="{ name: 'NewsShow', params: { id: item.id } }"
          v-for="item in recommend.lastFour"
          :key="item.id"
          class="f-left recommend-right-link"
        >
          <div
            class="recommend-right-item"
            :style="{ backgroundImage: 'url(' + item.thumb_img + ')' }"
          >
            <div class="recommend-title" :title="item.title">
              {{ item.title }}
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="clearfix news">
      <div class="f-left news-list">
        <div class="news-nav-container">
          <BlockTabs
            class="block-tabs tabs-4-3-7"
            :items="navList"
            currentClass="bold5"
            @changeTab="changeClassify"
          ></BlockTabs>
          <div class="index-nav" v-if="classifyList.length > 5">
            <a class="nav-left" @click="navToLeft"></a>
            <a class="nav-right" @click="navToRight"></a>
          </div>
        </div>
        <list
          ref="list"
          class="list"
          url="/api/app/information/index"
          method="post"
          :search="{ classify_id: classify }"
          alwaysShowPager
        >
          <template v-slot="{ list }">
            <div>
              <NewsRecommendItem
                v-for="item in list"
                :key="item.id"
                :item="item"
              ></NewsRecommendItem>
            </div>
            <Empty v-if="list.length == 0" class="empty" title="暂无资讯信息哦！" />
          </template>
        </list>
      </div>
      <div class="f-right hot-news">
        <div class="hot-title">热门资讯</div>
        <ul class="top-twos">
          <router-link
            :to="{ name: 'NewsShow', params: { id: item.id } }"
            v-for="(item, index) in topTwoHot"
            :key="item.id"
          >
            <li class="top-two">
              <img class="top-two-img" :src="item.thumb_img" />
              <img
                class="top-two-rank"
                src="@/assets/images/news/top1@3x.png"
                v-if="index == 0"
                style="width: 52px"
              />
              <img
                class="top-two-rank"
                src="@/assets/images/news/top2@3x.png"
                v-else
                style="width: 52px"
              />
            </li>
          </router-link>
        </ul>
        <ul class="hot-list">
          <li class="hot-item clearfix" v-for="(item, index) in hotNews" :key="item.id">
            <router-link :to="{ name: 'NewsShow', params: { id: item.id } }">
              <img :src="item.thumb_img" class="f-left hot-img" />
              <div class="f-left hot-item-title" :title="item.title">
                {{ item.title }}
              </div>
            </router-link>
            <div class="hot-rank">
              <img src="@/assets/images/news/top.png" />
              <span>{{ index + 3 }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import NewsRecommendItem from '../../components/rich/NewsRecommendItem.vue';

export default {
  name: 'News',
  components: { NewsRecommendItem },
  data() {
    return {
      recommend: {
        first: {},
        lastFour: [],
      },
      classifyList: [],
      classify: 0,
      page: 1,
      limit: 10,
      total: 0,
      news: [],
      topTwoHot: [],
      hotNews: [],
      index: 0,
    };
  },
  computed: {
    navList() {
      return this.classifyList.slice(this.index, this.index + 5);
    },
  },
  async created() {
    let recommendNews = await this.$http.get('/api/app/information/recommend');
    if (recommendNews.length > 0) {
      this.recommend.first = recommendNews[0];
      this.recommend.lastFour = recommendNews.splice(1, 4);
    }
    let classifyList = await this.$http.get('/api/app/information/classify');
    classifyList.unshift({ name: '全部', id: 0 });
    this.classifyList = classifyList;

    let hotNews = await this.$http.get('/api/app/information/hot');
    this.topTwoHot = hotNews.splice(0, 2);
    this.hotNews = hotNews;
  },
  methods: {
    async changeClassify(classify) {
      this.classify = classify.id;
      this.$nextTick(() => {
        this.$refs.list.searchRefresh();
      });
    },
    navToLeft() {
      if (this.index == 0) {
        return;
      }
      this.index--;
    },
    navToRight() {
      if (this.index >= this.classifyList.length - 5) {
        return;
      }
      this.index++;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../css/news.scss';
</style>
